import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Contacts, Contact, CreateContact, UpdateContact } from "./pages";

export const ContactsRouter = [
  <Route
    path="/contacts"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Contacts />
      </ProtectedRoute>
    }
  />,

  <Route path="/contact">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateContact />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Contact />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateContact />
        </ProtectedRoute>
      }
    />
  </Route>,
];
